import { ReactNode } from "react";

import Callout from "ds/components/Callout";
import FeedbackActions from "ds/components/Feedback/Actions";
import Link from "ds/components/Link";
import UserManagementWarningCalloutContent from "views/Account/Settings/UserManagementWarningCallout/Content";

import { MANAGE_SLACK_ACCESS_INFO_KEY } from "../constants";
import { UserManagementActivationStatus } from "../types";

type ManageSlackAccessPageLayoutProps = {
  activationStatus: UserManagementActivationStatus;
  children: ReactNode;
};

const ManageSlackAccessPageLayout = ({
  activationStatus,
  children,
}: ManageSlackAccessPageLayoutProps) => {
  const isUserManagementActive = activationStatus === UserManagementActivationStatus.ACTIVE;

  return (
    <>
      {isUserManagementActive ? (
        <Callout variant="info" storageKey={MANAGE_SLACK_ACCESS_INFO_KEY}>
          To assign Slack access to <strong>users</strong> navigate to user access details.
          <FeedbackActions>
            <Link size="small" href="/settings/users">
              Go to Users
            </Link>
          </FeedbackActions>
        </Callout>
      ) : (
        <UserManagementWarningCalloutContent />
      )}

      {children}
    </>
  );
};

export default ManageSlackAccessPageLayout;
